import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { PROFILE_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "config/protected-route";
import ProfileDetail from "./ProfileDetail/ProfileDetail";
import "./ProfileView.scss";

function ProfileView() {
  return (
    <Switch>
      <ProtectedRoute
        path={PROFILE_ROUTE}
        key={PROFILE_ROUTE}
        component={ProfileDetail}
        auth={true}
      />
      <Redirect from={PROFILE_ROUTE} to={PROFILE_ROUTE} />
    </Switch>
  );
}

export default ProfileView;
